module.exports = __webpack_public_path__ + "assets/img/coupons-icon.be5af27e.png";